import PayoutsModal from './PayoutsModal';

export default PayoutsModal;
